import React from "react"

import { MarkovVariableFilters } from "client/store"
import { SearchBar } from "client/components"

interface SearchMarkovVariable {
    id: string
    leftOffset?: boolean
    rightOffset?: boolean
    filters: MarkovVariableFilters
    onFilter: (filters: MarkovVariableFilters) => void
}

const MarkovVariableSearch = ({
    id,
    leftOffset = false,
    rightOffset = false,
    filters,
    onFilter,
}: SearchMarkovVariable) => (
    <SearchBar
        id={id}
        filters={filters}
        leftOffset={leftOffset}
        rightOffset={rightOffset}
        onFilter={onFilter}
    />
)
export default MarkovVariableSearch
